export function loadScript(src, checkForExisting = true, ...attributes) {
  return new Promise((resolve, reject) => {
    if (checkForExisting) {
      const existing = document.querySelectorAll(`script[src="${src}"]`)
      if (existing.length > 0) return resolve()
    }

    const scriptEl = document.createElement('script')
    scriptEl.setAttribute('src', src)

    Object.keys(attributes).forEach(key => {
      if (scriptEl[key] === undefined) {
        scriptEl.setAttribute(key, attributes[key])
      } else {
        scriptEl[key] = attributes[key]
      }
    })

    const handleLoad = () => resolve()
    const handleError = error => reject(error)

    scriptEl.addEventListener('load', handleLoad)
    scriptEl.addEventListener('error', handleError)

    document.body.appendChild(scriptEl)
  })
}
